<template>
  <div class="sim_server">

    <TextTable
      :all_data = "all_data"
    />

  </div>
</template>

<script>

import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';

export default {
  name: 'SimServer',
  components: {
    TextTable
  },
  props: {
    request: {
      type: String,
      default: 'all'
    }
  },

  data () {
    return {
      load: true,
      all_data: {}
    }
  },

  created () {
    this.get_sim_server()
  },

  methods: {
    get_sim_server(){
      this.$http.simcard.getSimServers((response) => {
        this.all_data = response.data
      })
    }
  },
}
</script>
<style lang='scss' scoped>
  .sim_server{
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
 </style>
